import { render, staticRenderFns } from "./LotteryTitle.vue?vue&type=template&id=6a1fcb40&scoped=true&"
import script from "./LotteryTitle.vue?vue&type=script&lang=js&"
export * from "./LotteryTitle.vue?vue&type=script&lang=js&"
import style0 from "./LotteryTitle.vue?vue&type=style&index=0&id=6a1fcb40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1fcb40",
  null
  
)

export default component.exports